<template>
	<view>
		<view class="container_h" >
			<view class="container_head" :style="{height: navHeight + 'px', marginTop: statusbarHeight + 'px'}">
				<view class="container_head_address" @click="go">
					<image src="@/static/icon/ar_back_dark@2x.png" mode="widthFix"></image>
				</view>
				<view class="page-title">提交审核</view>
			</view>
		</view>
		<view :style="{marginTop: (navHeight + statusbarHeight) + 'px'}"></view>
		<stepLine :active="2" :steps="steps"/>
		<view class="main-container">
			<view class="tips">正在审核</view>
			<view class="tips-detail">信息已提交，审核将在3个工作日以内完成，请注意查看</view>
		</view>
	</view>
</template>

<script>
	import stepLine from '@/components/common/stepLine.vue'
	import { mapState } from 'vuex'
	export default {
		components: {
			stepLine
		},
		data() {
			return {
				steps: [
					{ title: '基本信息' },
					{ title: '资质认证' },
					{ title: '提交审核' }
				],
			}
		},
		computed: {
			...mapState(['statusbarHeight', 'navHeight'])
		},
		methods: {
			go() {
				uni.navigateBack({
					delta: 3
				});
			}
		}
	}
</script>

<style lang="scss" scoped>
	.container_h {
		width: 100%;
		background-color: #f5f5f5;
		height: auto;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9;
		display: flex;
		.container_head {
			width: 100%;
			padding: 0 32rpx;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			.container_head_address {
				display: flex;
				align-items: center;
				justify-content: flex-start;
				image {
					width: 16rpx;
					height: 30rpx;
				}
			}
		}
		.page-title {
			flex: 1;
			text-align: center;
		}
	}
.main-container {
	text-align: center;
	margin-top: 158rpx;
	font-family: PingFang SC-Medium, PingFang SC;
	.tips {
		height: 40rpx;
		font-size: 40rpx;
		font-weight: 400;
		color: #333333;
		line-height: 40rpx;
	}
	.tips-detail {
		height: 24rpx;
		font-size: 24rpx;
		font-weight: 400;
		color: #999999;
		line-height: 24rpx;
		margin-top: 28rpx;
	}
}
</style>
